import React from 'react';
import PropTypes from 'prop-types'

import TabLink from '../tab_link/TabLink'

import css from './Navigation.module.scss'

const Navigation = ({tabs}) => {
  return (
    <div className={css.navigation}>
      {tabs.map((m) => {
        return <TabLink text={m.name} route={m.route} key={m.name} isTab />
      })}
    </div>
  )
}

Navigation.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    route: PropTypes.string.isRequired
  }))
}

Navigation.defaultProps = {
  tabs: []
}

export default Navigation;
